import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import { MAILING_DNS_SETTINGS_API, removeDomain } from 'modules/profile/mailing-settings/api/mailing-settings-domain-api';
import DnsSettingsModalWithButton from 'modules/profile/mailing-settings/components/dns-settings-modal-with-button';
import DomainTableSkeleton from 'modules/profile/mailing-settings/components/domain-table-skeleton';
import SetupDomainAuthentication from 'modules/profile/mailing-settings/components/setup-domain-authentication';
import { DomainStatusEnum } from 'modules/profile/mailing-settings/enums/domain-status-enum';
import { useMailingDnsSettings } from 'modules/profile/mailing-settings/hooks/use-mailing-dns-settings';
import { MailingSettingsDomainInterface } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface';
import React from 'react';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
function DomainTable() {
  const $ = _c(37);
  const {
    t
  } = useLocoTranslation();
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination(true);
  let t0;
  if ($[0] !== limit || $[1] !== pagination) {
    t0 = {
      pagination,
      limit
    };
    $[0] = limit;
    $[1] = pagination;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    dnsMailingSettings
  } = useMailingDnsSettings(t0);
  let t1;
  if ($[3] !== setPagination) {
    t1 = {
      setPagination,
      api: MAILING_DNS_SETTINGS_API
    };
    $[3] = setPagination;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const updateData = useUpdateData(t1);
  let t2;
  if ($[5] !== t) {
    t2 = t("dashboard.settings.mailing.setup_domain_modal_domain_name_title");
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = {
      key: "domainName",
      header: t2,
      widthPercent: 40,
      onRender: _temp
    };
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("global.status");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = domainData_0 => <div>{t(DomainStatusEnum[domainData_0.status])}</div>;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = {
      key: "status",
      header: t4,
      widthPercent: 30,
      onRender: t5
    };
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("dashboard.settings.mailing.dns_settings_title");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = {
      key: "dns-settings",
      header: t7,
      widthPercent: 30,
      onRender: _temp2
    };
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t3 || $[21] !== t6 || $[22] !== t8) {
    t9 = [t3, t6, t8];
    $[20] = t3;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const mailingSettingsDomainColumns = t9;
  let t10;
  if ($[24] !== dnsMailingSettings || $[25] !== updateData) {
    t10 = async id => {
      await removeDomain(id);
      await updateData(false, dnsMailingSettings);
    };
    $[24] = dnsMailingSettings;
    $[25] = updateData;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const onRemoveDomain = t10;
  let t11;
  if ($[27] !== dnsMailingSettings || $[28] !== limit || $[29] !== mailingSettingsDomainColumns || $[30] !== onRemoveDomain || $[31] !== pagination || $[32] !== setLimit || $[33] !== setPagination || $[34] !== t || $[35] !== updateData) {
    t11 = <>{dnsMailingSettings ? <div className="border-text-secondary/30 rounded-md border pb-4"><Table actions={{
          remove: {
            onChange: dns => onRemoveDomain(dns.id)
          }
        }} data={dnsMailingSettings} columns={mailingSettingsDomainColumns} limiter={{
          limit,
          setLimit
        }} paginator={{
          pagination,
          setPagination
        }} caption={t("dashboard.settings.mailing.dns_settings_domain_authentication_title")} emptyListWithTitles={true} /><SetupDomainAuthentication updateDomainTable={async () => {
          await updateData(false, dnsMailingSettings);
        }} /></div> : <DomainTableSkeleton />}</>;
    $[27] = dnsMailingSettings;
    $[28] = limit;
    $[29] = mailingSettingsDomainColumns;
    $[30] = onRemoveDomain;
    $[31] = pagination;
    $[32] = setLimit;
    $[33] = setPagination;
    $[34] = t;
    $[35] = updateData;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  return t11;
}
function _temp2(domainData_1) {
  return <DnsSettingsModalWithButton domainData={domainData_1} />;
}
function _temp(domainData) {
  return <div className="truncate"><Tooltip mode="overflow" label={domainData.domainName}><span className="truncate">{domainData.domainName}</span></Tooltip></div>;
}
export default DomainTable;